import React from 'react';
import { Alert as TypeAlert } from '../../../../../libs/models/Alert';
import { useAppDispatch, useAppSelector } from '../../../../../redux/app/hooks';
import { RootState } from '../../../../../redux/app/store';

const ALERT_STYLES = {
    success: {
        border: 'border-green-600',
        icon: (
            <svg className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
        ),
        title: 'Success',
    },
    warning: {
        border: 'border-amber-600',
        icon: (
            <svg className="h-5 w-5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4m0 4h.01M21 12A9 9 0 113 12a9 9 0 0118 0z"
                />
            </svg>
        ),
        title: 'Warning',
    },
    error: {
        border: 'border-red-600',
        icon: (
            <svg className="h-5 w-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
        ),
        title: 'Error',
    },
    info: {
        border: 'border-blue-600',
        icon: (
            <svg className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01" />
            </svg>
        ),
        title: 'Info',
    },
};

export const Alerts: React.FC = () => {
    const dispatch = useAppDispatch();
    const { alerts } = useAppSelector((state: RootState) => state.app);

    const getUniqueAlerts = (array: TypeAlert[]) => {
        return array.reduce((uniqueArray: TypeAlert[], obj: TypeAlert) => {
            const existingObject = uniqueArray.find((item: TypeAlert) => item.message === obj.message);
            if (!existingObject) {
                uniqueArray.push(obj);
            }
            return uniqueArray;
        }, []);
    };

    const uniqueAlerts = getUniqueAlerts(alerts);

    return (
        <div className="fixed top-4 right-4 z-50 flex flex-col gap-4 items-end">
            {uniqueAlerts.map(({ type, message }, index) => {
                const style = ALERT_STYLES[type] || ALERT_STYLES.info;
                return (
                    <div
                        key={`${index}-${type}`}
                        role="alert"
                        className={`flex w-full max-w-md items-start justify-between rounded-r-xl border-l-4 ${style.border} bg-slate-50 p-4 text-slate-800 shadow-xl dark:bg-slate-800 dark:text-slate-50`}>
                        <div className="flex items-start gap-4">
                            <div className="flex-1">
                                <strong className="block font-medium">{style.title}</strong>
                                <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">{message}</p>
                            </div>
                        </div>
                        <button
                            className="text-slate-500 transition hover:text-slate-600 dark:text-slate-400 dark:hover:text-slate-500"
                            onClick={() => dispatch({ type: 'app/removeAlert', payload: index })}>
                            <span className="sr-only">Dismiss popup</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                className="h-5 w-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                );
            })}
        </div>
    );
};
